<template>
  <div>
    <HeaderBox queue-table-hook>
      <HeaderBoxItem>
        {{ getTicketTitle }}
      </HeaderBoxItem>
      <HeaderBoxItem center>
        {{ getExecutorTitle }}
      </HeaderBoxItem>
      <HeaderBoxItem right>
        {{ getStateTitle }}
      </HeaderBoxItem>
    </HeaderBox>
    <TicketList ref="ticketList">
      <template v-for="(ticket, index) in tickets">
        <TicketListItem
          queue-ticket-list-item-hook
          :key="`ticket-list-item-${index}-${ticket.id}`"
        >
          <Ticket
            queue-ticket-hook
            :queue-ticket-label-hook="ticket.seatLabel"
            :queue-ticket-number-hook="ticket.ticketNumber"
            :queue-ticket-title-hook="ticket.title"
            :item="ticket"
          />
        </TicketListItem>
      </template>
    </TicketList>
  </div>
</template>

<script>
  import Ticket from '@/components/tickets/Ticket'
  import HeaderBox from '@/components/headers/HeaderBox'
  import TicketList from '@/components/tickets/TicketList'
  import HeaderBoxItem from '@/components/headers/HeaderBoxItem'
  import TicketListItem from '@/components/tickets/TicketListItem'

  export default {
    name: 'TableSimple',
    components: {
      Ticket,
      HeaderBox,
      TicketList,
      HeaderBoxItem,
      TicketListItem
    },
    props: {
      tickets: {
        type: Array
      }
    },
    computed: {
      getTicketTitle () {
        return this.$store.state.gui.settings.colorScheme.ticketTitle
            ? this.$store.state.gui.settings.colorScheme.ticketTitle
            : this.$t('common.talon')
      },
      getExecutorTitle () {
        return this.$store.state.gui.settings.colorScheme.executorTitle
            ? this.$store.state.gui.settings.colorScheme.executorTitle
            : this.$t('common.windowNumber')
      },
      getStateTitle () {
        return this.$store.state.gui.settings.colorScheme.stateTitle
            ? this.$store.state.gui.settings.colorScheme.stateTitle
            : this.$t('common.status')
      }
    }
  }
</script>
